/** Shopify CDN: Minification failed

Line 11:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 12:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 20:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 28:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:8 Transforming const to the configured target environment ("es5") is not supported yet

**/
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
